import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

function Pagination({ pageCount, handlePageClick, selectPage }) {
  return (
    <div className="content-info-cell -pagination">
      <ReactPaginate
        breakLabel={<span>...</span>}
        breakClassName="pagination-btn -other"
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        subContainerClassName="pages pagination"
        activeClassName="-active"
        previousClassName="pagination-btn -prev"
        nextClassName="pagination-btn -next"
        pageClassName="pagination-btn"
        pageLinkClassName="pagination-btn-link"
        forcePage={selectPage - 1}
      />
    </div>
  );
}

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  handlePageClick: PropTypes.func.isRequired,
  selectPage: PropTypes.number.isRequired,
};

export default Pagination;
